import { render, staticRenderFns } from "./TipoVigenciaForm.vue?vue&type=template&id=f610c89a"
import script from "./TipoVigenciaForm.vue?vue&type=script&lang=js"
export * from "./TipoVigenciaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports